import { OnInit, Component, Inject } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Misc } from "src/app/components/util/misc";
import { CustoAdicional } from "src/app/models/custo-adicional.model";
import { CustoAdicionalService } from "src/app/services/custo-adicional.service";

@Component({
    selector: "app-editar-custo-adicional-estimativa",
    templateUrl: "./editar-custo-adicional-estimativa.component.html",
    styleUrls: ["./editar-custo-adicional-estimativa.component.scss"],
})
export class EditarCustoAdicionalEstimativaDialogComponent implements OnInit {
    public basicFormModal: UntypedFormGroup;

    constructor(
        public dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: UntypedFormBuilder,
        private custoAdicionalService: CustoAdicionalService,
        public misc: Misc
    ) { }

    ngOnInit() {
        this.createEditForm(this.data);
    }

    createEditForm(custoAdicional: any) {
        this.basicFormModal = this.fb.group({
            quantidade: [custoAdicional.quantidade, Validators.required],
            valor: [custoAdicional.valor, Validators.required],
            descricao: [custoAdicional.descricao == null ? custoAdicional.tb_custo_adicional_tipo.descricao : custoAdicional.descricao]
        });
    }

    close(): void {
        this.dialogRef.close();
    }

    save() {
        const custoAdicional = new CustoAdicional();
        custoAdicional.id = this.data.id;
        custoAdicional.estimativaId = this.data.estimativaId;
        custoAdicional.descricao = this.data.descricao;
        custoAdicional.quantidade = this.basicFormModal.value.quantidade;
        custoAdicional.valor = this.basicFormModal.value.valor;
        custoAdicional.idCustoAdicionalTipo = this.data.idCustoAdicionalTipo;

        this.atualizarCustoAdicionalEstimativa(custoAdicional);
    }

    atualizarCustoAdicionalEstimativa(custoAdicional: CustoAdicional) {
        this.custoAdicionalService.update(custoAdicional).subscribe({
            next: (result) => {
                this.misc.mensagemSucesso('Custo Adicional da Estimativa atualizado com sucesso');
                this.dialogRef.close(result);
            },
            error: (error) => {
                this.misc.processError(error, 'Não foi possível atualizar o Custo Adicional da Estimativa');
            }
        }).add(() => {
        });
    }
}
